<template>
  <div class="ml-2 mr-4 pb-3">
    <validation-observer ref="rejectRef" v-slot="{}" tag="form">
      <div class="row mt-3">
        <div class="col-12">
          <em class="fas fa-times-circle text-orange mr-1" />
          <span class="color-gray-7 font-16 font-weight-bold">
            {{ title || 'Razón de Rechazo' }}
          </span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-sm-12 col-md-5 col-xl-5 col-lg-5 mb-4">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-drop-down
              v-model="reason"
              custom-error-msg="La razón de rechazo es requerida."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Razón de rechazo:"
              :options="reasonList"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>

        <div class="col-12 col-sm-12 col-md-5 col-xl-5 col-lg-5 mb-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-file-input
              accept=".pdf"
              custom-error-msg="Documento es requerido para esta solicitud."
              :error="errors[0]"
              label="Documento de Rechazo de Solicitud Horas Compensatorias:"
              label-position="left"
              :on-download="() => {}"
              :value="file"
              @input="(file) => onUploadFileHandler(file)"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <span class="color-gray-6 d-block font-14 mb-2">Comentario:</span>
          <span class="font-16 color-black">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-text-area
                v-model="comment"
                :count-classes="['float-right']"
                custom-error-msg="El comentario es requerido."
                :error="errors[0]"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
          </span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12">
          <action-button
            class="float-right ml-2"
            i="fas fa-save fa-lg"
            text="Guardar"
            variant="success mt-3"
            @click="onSave"
          />
          <action-button
            class="float-right"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mb-4 mt-3"
            @click="onCancel"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';

import { rejectCompensatoryRequest } from '@/services/provider/compensatoryRequest.api';
import { getRejectReasons as _getRejectReasons } from '@/services/provider/compensatoryRequest.api';
import compensatoryRequestStatus from '@/utils/constants/compensatoryRequestStatus';
import objectToFormData from 'object-to-formdata';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'RejectRequest',
  components: {
    CustomDropDown,
    CustomTextArea,
    ActionButton,
    CustomFileInput,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    comment: null,
    reason: null,
    file: null,
    reasonList: [],
  }),
  async mounted() {
    await _getRejectReasons().then((resp) => (this.reasonList = resp.data));
  },
  methods: {
    onCancel() {
      this.comment = null;
      this.reason = null;
      this.$emit('on-cancel');
    },
    async onSave() {
      const isValid = await this.$refs.rejectRef.validate();
      if (isValid) {
        const answer = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea rechazar la solicitud?`,
          'Sí',
          'No'
        );
        if (!answer) return;

        let payload = {
          requestId: this.value.requestId,
          statusId: compensatoryRequestStatus.CompletadoPendientedeAprobacion,
          comment: this.comment,
          reasonId: this.reason.id,
          file: this.file,
        };

        let formData = objectToFormData(payload, {
          indices: true,
          nullsAsUndefineds: true,
        });

        await rejectCompensatoryRequest(formData)
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso.',
              'La solicitud ha sido rechazada exitosamente.',
              'success'
            );
            this.$emit('on-save');
          })
          .catch(() =>
            this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
          );
      }
    },
    onUploadFileHandler(file) {
      this.file = file;
    },
  },
};
</script>
